import {Box, Stack, Typography} from '@mui/material';
import {type PlanSettingsCountryEnum, type PlanSettings} from 'client/';
import {SingleSelect} from 'components/Shared/SingleSelect';
import {useTranslation} from 'react-i18next';

export const PlanSettingsCountrySelector = ({
  setPlanSettings,
  planSettings,
}: {
  setPlanSettings: React.Dispatch<React.SetStateAction<PlanSettings | undefined>>;
  planSettings: PlanSettings | undefined;
}) => {
  const {t} = useTranslation('common');
  return (
    <Stack direction={'row'} justifyContent="space-between" alignItems="flex-start" width="100%">
      <Stack spacing={1}>
        <Typography variant="h6">{t('planSettingsCountry')}</Typography>
        <Typography variant="caption" color="text.disabled">
          {t('planSettingsCountryCaption')}
        </Typography>
      </Stack>
      <Box display="flex" justifyContent="flex-end" minWidth={200}>
        <SingleSelect
          onClick={(country) => {
            planSettings && setPlanSettings({...planSettings, country});
          }}
          selectedKey={planSettings?.country}
          options={
            new Map<PlanSettingsCountryEnum, string>([
              ['NORWAY', t('Norway')],
              ['CHILE', t('Chile')],
            ])
          }
        />
      </Box>
    </Stack>
  );
};
